export function convertMillisToHoursMinutes(milliseconds: string): string {
  const millis = +milliseconds;

  if (millis === null || millis === undefined || millis < 0) {
    return '-:-- hours';
  }

  const minutes = Math.floor(millis / 60000);
  const seconds = Math.floor((millis / 1000) % 60);

  return minutes + ':' + (seconds < 10 ? '0' + seconds : seconds);
}
